<template>
    <b-card title="" class="trigger-card p-2 mb-2" no-body>
        <template #header class="p-2">
            <div class="d-flex justify-content-between align-items-center w-100">
                <h6 class="text-primary">Only Send Trigger <b>If</b></h6>
            </div>
        </template>
        <b-card-body class="p-2">
            <div class="readonly-overlay" v-if="readonly"></div>
            <b-collapse visible id="collapse_conditions">
                <hr class="m-0 mb-3" />

                <b-row class="pl-3 pt-2 pb-2 pr-2 mb-2 mx-lg-5">
                    <div
                        class="condition-string text-primary d-flex align-items-center mb-2"
                        v-for="(conditionLabels, i) in generateConditionString"
                        :key="uuid() + i"
                    >
                        <div v-if="isArray(conditionLabels)" class="d-flex or-items-wrapper">
                            <div
                                v-for="(c, i2) in conditionLabels"
                                :key="i2 + uuid()"
                                class="d-flex align-items-center or-item"
                            >
                                <div
                                    class="condition-string-item"
                                    :class="{
                                        'rounded-left': i2 === 0,
                                        'rounded-right': i2 === conditionLabels.length - 1,
                                    }"
                                >
                                    {{ c.source }}
                                    &nbsp; &nbsp;

                                    {{ c.operator }}
                                    &nbsp; &nbsp;

                                    {{ c.target }}
                                </div>
                                <div v-if="i2 !== conditionLabels.length - 1" class="condition-or-item">
                                    <b>OR</b>
                                </div>
                            </div>
                        </div>
                        <div v-else class="condition-string-item rounded">
                            {{ conditionLabels.source }}
                            &nbsp; &nbsp;

                            {{ conditionLabels.operator }}
                            &nbsp; &nbsp;

                            {{ conditionLabels.target }}
                        </div>
                        <div v-if="i !== generateConditionString.length - 1" class="pr-2 pl-2">
                            <b>And</b>
                        </div>
                    </div>
                </b-row>
                <b-row
                    v-for="(condition, i) in conditions"
                    :key="i + uuid()"
                    class="align-items-center flex-wrap mb-2 ml-0 mr-0 mx-lg-5 px-lg-3"
                >
                    <b-col class="trigger-or-block" md="12" v-if="isArray(condition)">
                        <b-row
                            class="mr-0 ml-0 mb-2 event-row-align"
                            v-for="(c, i2) in condition"
                            :key="c.source + c.operator + c.target + i2 + i"
                        >
                            <b-col
                                class="mb-md-0 mb-2 d-flex justify-content-center align-items-center justify-content-md-start event-word"
                                md="1"
                                :class="{
                                    'date-range-condition': getIsRangeConditions(c.source),
                                }"
                                v-if="i2 !== 0"
                                ><b>OR</b></b-col
                            >
                            <b-col
                                md="1"
                                class="mb-md-0 mb-2 d-flex justify-content-center align-items-center justify-content-md-start event-word"
                                :class="{
                                    'date-range-condition': getIsRangeConditions(c.source),
                                }"
                                v-else
                                ><b>If</b></b-col
                            >

                            <b-col md="4">
                                <validation-provider
                                    
                                    v-slot="{ errors }"
                                    :name="getConditionVID(c.source, i, i2).source"
                                    :class="{
                                        'date-range-condition': getIsRangeConditions(c.source),
                                    }"
                                >
                                    <form-dropdown
                                        :value="c.source"
                                        class="mb-md-0"
                                        :options="conditionIdentifiers"
                                        :disabled="readonly"
                                        @input="(val) => onSelectCondition(val, 'source', i, i2)"
                                        :isGrouped="true"
                                        placeholder="Select Condition"
                                        :error="errors[0] || getEventError(c.source, 'required')"
                                    />
                                </validation-provider>
                            </b-col>
                            <b-col md="3" v-if="getIsRangeConditions(c.source)">
                                <div class="w-100 d-flex flex-column">
                                    <validation-provider
                                        
                                        v-slot="{ errors }"
                                        class="mb-2 d-block"
                                        :name="getConditionVID(c.source, i, i2).from_month"
                                    >
                                        <form-dropdown
                                            v-model="c.from_month"
                                            class="mb-md-0"
                                            :options="monthOptions"
                                            :disabled="readonly"
                                            @input="(val) => onSelectCondition(val, 'from_month', i, i2)"
                                            label="Start Month"
                                            placeholder="Select Month"
                                            :error="errors[0] || getEventError(c.from_month, 'required')"
                                        />
                                    </validation-provider>
                                    <validation-provider
                                        
                                        v-slot="{ errors }"
                                        v-if="getIsRangeConditions(c.source) && c.from_month"
                                        :name="getConditionVID(c.source, i, i2).from_day"
                                        class="mb-2 d-block"
                                    >
                                        <form-dropdown
                                            v-model="c.from_day"
                                            class="mb-md-0 mt-md-2"
                                            :options="yearlyMonthDayOptions(c.from_month)"
                                            :disabled="readonly"
                                            @input="(val) => onSelectCondition(val, 'from_day', i, i2)"
                                            label="Start Day"
                                            placeholder="Select Day"
                                            :error="errors[0] || getEventError(c.from_day, 'required')"
                                        />
                                    </validation-provider>
                                </div>
                            </b-col>
                            <b-col md="3" v-if="getIsRangeConditions(c.source)">
                                <div class="w-100 d-flex flex-column">
                                    <validation-provider
                                        
                                        v-slot="{ errors }"
                                        class="mb-2 d-block"
                                        :name="getConditionVID(c.source, i, i2).to_month"
                                    >
                                        <form-dropdown
                                            v-model="c.to_month"
                                            class="mb-md-0"
                                            :options="monthOptions"
                                            :disabled="readonly"
                                            @input="(val) => onSelectCondition(val, 'to_month', i, i2)"
                                            label="End Month"
                                            placeholder="Select Month"
                                            :error="errors[0] || getEventError(c.to_month, 'required')"
                                        />
                                    </validation-provider>
                                    <validation-provider
                                        
                                        v-slot="{ errors }"
                                        v-if="getIsRangeConditions(c.source) && c.to_month"
                                        :name="getConditionVID(c.source, i, i2).to_day"
                                        class="mb-2 d-block"
                                    >
                                        <form-dropdown
                                            v-model="c.to_day"
                                            class="mb-md-0 mt-md-2"
                                            :options="yearlyMonthDayOptions(c.to_month)"
                                            :disabled="readonly"
                                            @input="(val) => onSelectCondition(val, 'to_day', i, i2)"
                                            label="End Day"
                                            placeholder="Select Day"
                                            :error="errors[0] || getEventError(c.to_day, 'required')"
                                        />
                                    </validation-provider>
                                </div>
                            </b-col>
                            <b-col md="2" v-if="!getIsRangeConditions(c.source)">
                                <validation-provider
                                    
                                    v-slot="{ errors }"
                                    :name="getConditionVID(c.source, i, i2).operator"
                                >
                                    <form-dropdown
                                        class="mb-md-0"
                                        v-model="c.operator"
                                        :options="getConditionsOptions(c.source).operator"
                                        :disabled="!c.source || readonly"
                                        @input="(val) => onSelectCondition(val, 'operator', i, i2)"
                                        placeholder="Select Condition Action"
                                        :error="errors[0] || getEventError(c.operator, c.source && 'required')"
                                    />
                                </validation-provider>
                            </b-col>
                            <b-col md="4" v-if="!getIsRangeConditions(c.source)">
                                <validation-provider
                                    
                                    v-slot="{ errors }"
                                    :name="getConditionVID(c.source, i, i2).target"
                                >
                                    <form-dropdown
                                        class="mb-md-0"
                                        v-model="c.target"
                                        :options="getConditionsOptions(c.source).target"
                                        :disabled="!c.source || readonly"
                                        @input="(val) => onSelectCondition(val, 'target', i, i2)"
                                        placeholder="Select Condition Status"
                                        :error="errors[0] || getEventError(c.target, c.source && 'required')"
                                    />
                                </validation-provider>
                            </b-col>
                            <b-col
                                md="1"
                                class="d-flex justify-content-center remove-event-wrapper align-items-start"
                                :class="{
                                    'date-range-condition': getIsRangeConditions(c.source),
                                }"
                            >
                                <b-button
                                    class="align-baseline btn-circle-minus"
                                    title="Remove"
                                    variant="danger"
                                    size="xs"
                                    v-if="!readonly"
                                    @click="
                                        removeCondition({
                                            index: i,
                                            nestedIndex: i2,
                                        })
                                    "
                                    ><font-awesome-icon :icon="['fas', 'minus']"></font-awesome-icon
                                ></b-button>
                            </b-col>
                            <b-col class="d-flex d-md-none">
                                <hr class="condition-separator w-100" />
                            </b-col>
                        </b-row>
                        <div class="w-100 mt-3 d-flex justify-content-center" v-if="!readonly">
                            <div @click="addCondition(i)" class="d-flex align-items-center">
                                <b-button
                                    class="align-baseline btn-circle-plus mr-1"
                                    title="Add"
                                    variant="primary"
                                    size="xs"
                                    ><font-awesome-icon :icon="['fas', 'plus']"></font-awesome-icon
                                ></b-button>
                                <span class="text-primary cursor-pointer"> Add <b>OR</b> Condition </span>
                            </div>
                        </div>
                    </b-col>
                    <b-col md="12" class="pr-0 pl-0" v-else>
                        <b-row class="mr-0 ml-0 mb-2 event-row-align">
                            <b-col md="5" class="pl-md-0">
                                <validation-provider
                                    
                                    v-slot="{ errors }"
                                    :name="getConditionVID(condition.source, i).source"
                                    :class="{
                                        'date-range-condition': getIsRangeConditions(condition.source),
                                    }"
                                >
                                    <form-dropdown
                                        :value="condition.source"
                                        class="mb-md-0"
                                        :options="conditionIdentifiers"
                                        :disabled="readonly"
                                        @input="(val) => onSelectCondition(val, 'source', i)"
                                        :isGrouped="true"
                                        placeholder="Select Condition"
                                        :error="errors[0] || getEventError(condition.source, 'required')"
                                    />
                                </validation-provider>
                            </b-col>
                            <b-col md="3" v-if="getIsRangeConditions(condition.source)">
                                <div class="w-100 d-flex flex-column">
                                    <validation-provider
                                        
                                        v-slot="{ errors }"
                                        class="mb-2 d-block"
                                        :name="getConditionVID(condition.source, i).from_month"
                                    >
                                        <form-dropdown
                                            v-model="condition.from_month"
                                            class="mb-md-0"
                                            :options="monthOptions"
                                            :disabled="readonly"
                                            @input="(val) => onSelectCondition(val, 'from_month', i)"
                                            label="Start Month"
                                            placeholder="Select Month"
                                            :error="errors[0] || getEventError(condition.from_month, 'required')"
                                        />
                                    </validation-provider>
                                    <validation-provider
                                        
                                        v-slot="{ errors }"
                                        v-if="getIsRangeConditions(condition.source) && condition.from_month"
                                        :name="getConditionVID(condition.source, i).from_day"
                                    >
                                        <form-dropdown
                                            v-model="condition.from_day"
                                            class="mb-md-0"
                                            :options="yearlyMonthDayOptions(condition.from_month)"
                                            :disabled="readonly"
                                            @input="(val) => onSelectCondition(val, 'from_day', i)"
                                            label="Start Day"
                                            placeholder="Select Day"
                                            :error="errors[0] || getEventError(condition.from_day, 'required')"
                                        />
                                    </validation-provider>
                                </div>
                            </b-col>
                            <b-col md="3" v-if="getIsRangeConditions(condition.source)">
                                <div class="w-100 d-flex flex-column">
                                    <validation-provider
                                        
                                        v-slot="{ errors }"
                                        class="mb-2 d-block"
                                        :name="getConditionVID(condition.source, i).to_month"
                                    >
                                        <form-dropdown
                                            v-model="condition.to_month"
                                            class="mb-md-0"
                                            :options="monthOptions"
                                            :disabled="readonly"
                                            @input="(val) => onSelectCondition(val, 'to_month', i)"
                                            label="End Month"
                                            placeholder="Select Month"
                                            :error="errors[0] || getEventError(condition.to_month, 'required')"
                                        />
                                    </validation-provider>
                                    <validation-provider
                                        
                                        v-slot="{ errors }"
                                        v-if="getIsRangeConditions(condition.source) && condition.to_month"
                                        :name="getConditionVID(condition.source, i).to_day"
                                    >
                                        <form-dropdown
                                            v-model="condition.to_day"
                                            class="mb-md-0"
                                            :options="yearlyMonthDayOptions(condition.to_month)"
                                            :disabled="readonly"
                                            @input="(val) => onSelectCondition(val, 'to_day', i)"
                                            label="End Day"
                                            placeholder="Select Day"
                                            :error="errors[0] || getEventError(condition.to_day, 'required')"
                                        />
                                    </validation-provider>
                                </div>
                            </b-col>
                            <b-col md="2" v-if="!getIsRangeConditions(condition.source)">
                                <validation-provider
                                    
                                    v-slot="{ errors }"
                                    :name="getConditionVID(condition.source, i).operator"
                                >
                                    <form-dropdown
                                        class="mb-md-0"
                                        v-model="condition.operator"
                                        :options="getConditionsOptions(condition.source).operator"
                                        :disabled="!condition.source || readonly"
                                        @input="(val) => onSelectCondition(val, 'operator', i)"
                                        placeholder="Select Condition Action"
                                        :error="
                                            errors[0] ||
                                            getEventError(condition.operator, condition.source && 'required')
                                        "
                                    />
                                </validation-provider>
                            </b-col>
                            <b-col md="4" v-if="!getIsRangeConditions(condition.source)">
                                <validation-provider
                                    
                                    v-slot="{ errors }"
                                    :name="getConditionVID(condition.source, i).target"
                                >
                                    <form-dropdown
                                        class="mb-md-0"
                                        v-model="condition.target"
                                        :options="getConditionsOptions(condition.source).target"
                                        :disabled="!condition.source || readonly"
                                        @input="(val) => onSelectCondition(val, 'target', i)"
                                        placeholder="Select Condition Status"
                                        :error="
                                            errors[0] || getEventError(condition.target, condition.source && 'required')
                                        "
                                    />
                                </validation-provider>
                            </b-col>
                            <b-col
                                md="1"
                                class="d-flex justify-content-center remove-event-wrapper align-items-start"
                                :class="{
                                    'date-range-condition': getIsRangeConditions(condition.source),
                                }"
                            >
                                <b-button
                                    class="align-baseline btn-circle-minus"
                                    title="Remove"
                                    variant="danger"
                                    size="xs"
                                    v-if="!readonly"
                                    @click="
                                        removeCondition({
                                            index: i,
                                            nestedIndex: null,
                                        })
                                    "
                                    ><font-awesome-icon :icon="['fas', 'minus']"></font-awesome-icon
                                ></b-button>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col
                        md="12"
                        class="pr-0 pl-0"
                        v-if="
                            conditions[i + 1] &&
                            ((conditions[i + 1] && isObject(conditions[i + 1])) ||
                                (conditions[i - 1] && isArray(conditions[i - 1])))
                        "
                    >
                        <b-col class="d-flex d-md-none">
                            <hr class="condition-separator w-100" />
                        </b-col>
                        <b-row class="mr-0 ml-0 mb-2 align-items-center mt-2 ml-lg-2">
                            <b-col
                                class="pr-0 pl-0 d-flex justify-content-md-start justify-content-center align-items-center event-word"
                                :class="{
                                    'date-range-condition': getIsRangeConditions(condition.source),
                                }"
                                md="12"
                                ><b>AND</b></b-col
                            >
                        </b-row>
                    </b-col>
                </b-row>
                <hr class="m-0 my-4" />
                <div class="w-100 d-flex justify-content-center" v-if="hasSelectedCondition && !readonly">
                    <div @click="addCondition(null)" class="d-flex align-items-center">
                        <b-button class="align-baseline btn-circle-plus mr-1" title="Add" variant="primary" size="xs"
                            ><font-awesome-icon :icon="['fas', 'plus']"></font-awesome-icon
                        ></b-button>
                        <span class="text-primary cursor-pointer"> Add <b>AND</b> Condition </span>
                    </div>
                </div>
            </b-collapse>
        </b-card-body>
    </b-card>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import isArray from 'lodash/isArray';
    import isObject from 'lodash/isObject';
    import FormInput from '../../../generic/form-input/form-input.vue';
    import FormDropdown from '../../../generic/form-dropdown/form-dropdown.vue';
    import { triggerMixin } from '../mixins/mixin';
    import { uuid } from '../../../../utils/objects';
    import { DAY_OF_THE_WEEK, DEPARTURE_DATE_RANGE, ARRIVAL_DATE_RANGE } from '../helpers/constants';
    import { monthOptions, yearlyMonthDayOptions, generateDateRangeString } from '../helpers/helpers';

    export default {
        mixins: [triggerMixin],
        components: {
            FormInput,
            FormDropdown,
        },
        computed: {
            ...mapGetters('trigger', ['conditions', 'conditionIdentifiers', 'conditionOptions', 'readonly']),
            monthOptions,
            generateConditionString() {
                return this.conditions
                    .map((item) => {
                        if (this.isArray(item)) {
                            return item
                                .map((p) => {
                                    return this.getConditionLabelObj(p, true);
                                })
                                .filter((p) => p);
                        } else {
                            return this.getConditionLabelObj(item, true);
                        }
                    })
                    .filter((i) => {
                        if (Array.isArray(i)) {
                            return i.length;
                        }
                        return i;
                    });
            },
            hasSelectedCondition() {
                return this.conditions.length >= 1 && (this.conditions[0].length > 0 || this.conditions.length > 1);
            },
        },
        methods: {
            ...mapActions('trigger', ['addCondition', 'removeCondition']),
            uuid,
            isArray,
            isObject,
            yearlyMonthDayOptions,
            generateDateRangeString,
            getConditionVID(identifier, i, nestedIndex) {
                const baseName = `conditions_store.conditions.${i}${
                    nestedIndex !== undefined ? '[' + nestedIndex + ']' : ''
                }`;
                const idString = `${baseName}.identifier`;
                const targetString = `${baseName}.target`;
                if (identifier === DAY_OF_THE_WEEK) {
                    return {
                        source: idString,
                        operator: targetString,
                        target: `${baseName}.day`,
                    };
                }
                if (identifier === DEPARTURE_DATE_RANGE || identifier == ARRIVAL_DATE_RANGE) {
                    return {
                        source: idString,
                        operator: targetString,
                        target: `${baseName}.day`,
                        from_month: `${baseName}.from_month`,
                        from_day: `${baseName}.from_day`,
                        to_day: `${baseName}.to_day`,
                        to_month: `${baseName}.to_month`,
                    };
                }
                return {
                    source: idString,
                    operator: `${baseName}.action`,
                    target: `${baseName}.status`,
                };
            },
            getIsRangeConditions(identifier) {
                return identifier === DEPARTURE_DATE_RANGE || identifier === ARRIVAL_DATE_RANGE;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../styles.scss';
</style>
